/**
 * <pdp-stock-meter>
 * Shows a "only N left" number that stays stable within one session
 * (sessionStorage-backed). In "fixed" mode the value is hardcoded;
 * in "random" mode JS picks once in [min, max] and persists it.
 *
 * Expects data attributes:
 *   data-mode   "fixed" | "random"
 *   data-min    integer (lower bound for random)
 *   data-max    integer (upper bound for random)
 *   data-fixed  integer (used when mode === "fixed")
 *
 * Updates the textContent of [data-count].
 */
if (!customElements.get('pdp-stock-meter')) {
  customElements.define(
    'pdp-stock-meter',
    class PdpStockMeter extends HTMLElement {
      constructor() {
        super();
        this.countEl = this.querySelector('[data-count]');
        this.mode = this.dataset.mode === 'fixed' ? 'fixed' : 'random';
        this.min = Number(this.dataset.min) || 5;
        this.max = Number(this.dataset.max) || 15;
        this.fixed = Number(this.dataset.fixed) || 9;
        this.storageKey = 'pdp-stock-' + (window.location.pathname || 'default');
      }

      connectedCallback() {
        if (!this.countEl) return;
        const value = this.mode === 'fixed' ? this.fixed : this.resolveRandom();
        this.countEl.textContent = String(value);
      }

      resolveRandom() {
        const stored = this.readStored();
        if (stored !== null) return stored;
        const low = Math.min(this.min, this.max);
        const high = Math.max(this.min, this.max);
        const value = Math.floor(Math.random() * (high - low + 1)) + low;
        this.writeStored(value);
        return value;
      }

      readStored() {
        try {
          const raw = window.sessionStorage.getItem(this.storageKey);
          return raw === null ? null : Number(raw);
        } catch {
          return null;
        }
      }

      writeStored(value) {
        try {
          window.sessionStorage.setItem(this.storageKey, String(value));
        } catch {
          /* sessionStorage unavailable - silently skip persistence */
        }
      }
    }
  );
}
